<template>
  <div v-if="isAuth" class="login-btn">
    <button @click="logout" class="">Log out</button>
  </div>
  <div
    v-else
    class="login-btn"
    :class="{
      active: $route.path.includes('/login'),
    }"
  >
    <a :href="$getSubdomainLink('portal', '/login')" class="">Log in</a>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores";
export default {
  name: "LoginBtn",
  data() {
    return {
      authStore: useAuthStore(),
    };
  },
  methods: {
    logout() {
      this.authStore.logout();
    },
  },
  computed: {
    isAuth() {
      return this.authStore.isAuth;
    },
  },
};
</script>
